import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { TarifarioService } from '../../services/tarifario.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import {NgIf} from '@angular/common';
import {NzButtonComponent} from 'ng-zorro-antd/button';

@Component({
  selector: 'app-editar-tarifa',
  templateUrl: './editar-tarifa.component.html',
  imports: [
    ReactiveFormsModule,
    NgIf,
    NzButtonComponent
  ],
  styleUrls: ['./editar-tarifa.component.css']
})

export class EditarTarifaComponent implements OnInit {
  tarifa: any; // Ahora se asignará desde el modal
  @Output() updateSuccess = new EventEmitter<void>();
  editarTarifaForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private tarifarioService: TarifarioService,
    private modal: NzModalRef
  ) {
    this.editarTarifaForm = this.fb.group({
      tarifa_por_hora: [null, [Validators.required, Validators.min(0)]]
    });
  }

  ngOnInit(): void {
    this.tarifa = this.modal.getConfig().nzData?.tarifa; // Obtiene tarifa del modal
    if (this.tarifa) {
     // console.log('Tarifa in ngOnInit:', this.tarifa);
      this.editarTarifaForm.patchValue({ tarifa_por_hora: this.tarifa.tarifa_por_hora });
    } else {
      //console.error('Tarifa is undefined in ngOnInit');
    }
  }

  onSubmit(): void {
    if (this.editarTarifaForm.valid && this.tarifa) {
      const updatedTarifa = { tarifa_por_hora: this.editarTarifaForm.value.tarifa_por_hora };

      this.tarifarioService.updateTarifa(this.tarifa.id_tarifa, updatedTarifa).subscribe(
        () => {
          this.updateSuccess.emit(); // 🔹 Emitir evento para indicar éxito
          this.modal.close(true); // 🔹 Cerrar modal y pasar true como señal de éxito
        },
        (error) => {
         // console.error('Error updating tarifa:', error);
        }
      );
    }
  }


  onCancel(): void {
    this.modal.close();
  }
}
